import React, { Component } from 'react';
import Styles from "../Styles.js";
import { GlobalContext } from '../global-context';

export default class HomeContainer extends Component {
  static contextType = GlobalContext;

  render() {
    const { navigate } = this.props;
    const person = this.context.person;

    return (
      <div style={{padding: "20px"}}>
        <Styles>
          <div style={{marginBottom: "20px"}}>
            <h2>Hello, {person.name} {person.surname}</h2>
          </div>
          <div style={{margin: "25px 0px 50px"}}>Welcome to the UVA Research Computing Service Management Portal.</div>
          <div className="link" onClick={() => navigate("ivyvm")}>
              Request an Ivy VM
          </div>
        </Styles>
      </div>
    );
  }
}
